import { Box, Typography, Link, IconButton, EmailOutlinedIcon, Instagram } from 'src/components';
import { useNavigate } from 'react-router-dom';
import { useIsMobile } from 'src/hooks';

export default function DesktopFooter() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 4,
        py: 1,
        borderTop: '1px solid #e0e0e0',
      }}
    >
      <Box sx={{ display: 'flex', gap: isMobile ? 1.5 : 3, mb: 1, mt: 1 }}>
        <Typography variant={isMobile ? "body2" : "subtitle1"} color="text.secondary">
          © {new Date().getFullYear()} PanAmExplorer. 
        </Typography>
        <Link href="/privacy-policy" underline="none" variant={isMobile ? "body2" : "subtitle1"} color="text.secondary">
          Privacy
        </Link>
        <Link href="/terms-of-service" underline="none" variant={isMobile ? "body2" : "subtitle1"} color="text.secondary">
          Terms
        </Link>
      </Box>

      <Box>
        <IconButton
          href="https://instagram.com/PanAm.Explorer"
          target="_blank"
          rel="noopener"
          disableRipple
          sx={{ p: 0.5, '&:hover': { color: 'primary.main' } }}
        >
          <Instagram />
        </IconButton>
        <IconButton
          disableRipple
          sx={{ p: 0.5, '&:hover': { color: 'primary.main' } }}
          onClick={() => navigate('/contact-us')}
        >
          <EmailOutlinedIcon />
        </IconButton>
      </Box>
    </Box>
  );
}
